import { makeStyles } from 'cdh-data-portal-theme'
import { SIDEBAR_WIDTH } from '../../molecules/Sidebar/Sidebar.static'

export const useStyles = makeStyles()((theme) => ({
  root: {
    minHeight: '100vh',
    padding: '89px 42px 48px',
    backgroundColor: theme.colors.globalBackgroundLight,
    transition: theme.transitions.easeOutFast,
    [theme.breakpoints.down('sm')]: {
      padding: '80px 20px 32px',
    },
    marginLeft: SIDEBAR_WIDTH
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  title: {
    '&&': {
      margin: 0,
      fontSize: 36,
      fontWeight: 500,
      lineHeight: '48px',
    },
    [theme.breakpoints.down('sm')]: {
      '&&': {
        fontSize: 30,
        lineHeight: '40px',
      },
    },
  },
  tabsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    marginTop: 24,
    flexWrap: 'wrap',
  },
  // Matches cdh-data-portal-internal's CatalogTabSwitch/TabButton look: a single bordered,
  // shadowed row of buttons instead of MUI's underlined text tabs.
  tabButtonGroup: {
    display: 'flex',
    height: 52,
    borderRadius: 4,
    boxShadow: theme.shadows.medium,
    overflow: 'hidden',
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 120,
    padding: '0 24px',
    border: 'none',
    borderRight: theme.borders.primary,
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:last-child': {
      borderRight: 'none',
    },
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  tabButtonSelected: {
    backgroundColor: theme.colors.primary,
    '&:hover': {
      backgroundColor: theme.colors.primary,
    },
  },
  environmentInline: {
    minWidth: 160,
  },
  summaryRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginTop: 24,
    flexWrap: 'wrap',
  },
  activeFiltersRow: {
    marginTop: 16,
  },
  filterBarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  feedback: {
    marginBottom: 20,
  },
  table: {
    marginTop: 24,
  },
  emptyState: {
    padding: '24px 20px',
  },
  dialogFields: {
    display: 'grid',
    gap: 24,
  },
  dialogRow: {
    display: 'grid',
    gap: 24,
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
  },
  dialogWarning: {
    marginTop: 8,
  },
}))
